import SectionHeading from "@/pages/home/components/SectionHeading";
import { addressReasons, addressChannels, verifyTips } from "@/mocks/doumanData";

export default function AddressSection() {
  return (
    <section id="address" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="最新地址"
          title="地址为什么会变？又该到哪里找最新的？"
          desc="与其反复搜索旧网址，不如弄清楚地址变化的规律，以及从哪些稳定渠道获取最新入口，这样才能长久不迷路。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {addressReasons.map((item) => (
            <article key={item.title} className="p-5 rounded-lg bg-background-100 border border-background-200">
              <span className="w-11 h-11 rounded-lg bg-secondary-100 text-secondary-900 flex items-center justify-center">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-8">
          <div className="lg:col-span-3">
            <h3 className="font-heading font-bold text-xl text-foreground-950 flex items-center gap-2">
              <i className="ri-links-line text-primary-600" aria-hidden="true"></i>
              获取最新地址的四个可靠渠道
            </h3>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {addressChannels.map((channel) => (
                <div
                  key={channel.title}
                  className="p-5 rounded-lg bg-primary-50 border border-primary-100 flex gap-3"
                >
                  <i className={`${channel.icon} text-xl text-primary-600 mt-0.5`} aria-hidden="true"></i>
                  <div>
                    <h4 className="font-heading font-bold text-sm text-foreground-950">{channel.title}</h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{channel.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-2 p-6 md:p-7 rounded-lg bg-accent-50 border border-accent-200">
            <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
              <i className="ri-shield-star-line text-accent-700" aria-hidden="true"></i>
              如何辨别入口是否正规
            </h3>
            <ul className="mt-5 space-y-4">
              {verifyTips.map((tip) => (
                <li key={tip} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                  <span className="shrink-0 w-6 h-6 rounded-full bg-accent-500 text-background-50 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-sm" aria-hidden="true"></i>
                  </span>
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}